/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_QuantityInputs */

const vi_order_quantity = /** @type {(inputs: Order_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SL`)
};

/**

* @param {Order_QuantityInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_quantity = /** @type {((inputs?: Order_QuantityInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_QuantityInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_quantity(inputs)
});